module.exports = __webpack_public_path__ + "static/media/header-ChargeReward.50ec9305.png";